module.exports = __webpack_public_path__ + "static/media/redSmiley.b7adba4a.png";